<section class="landing">
  <div
    class="no-results"
    *ngIf="
      featuredTitles?.length === 0 &&
      upcomingTitles?.length === 0 &&
      onReleaseTitles.length === 0 &&
      recentUploadedAssetsTitles?.length === 0 &&
      showNoResults
    "
  >
    <div class="no-results__text">{{ 'no-active-titles-for-this-territory-text' | translate }}</div>
  </div>
  <div class="featured-titles" *ngIf="featuredTitles?.length > 0; else loadingFeaturedTitles">
    <swiper-container
      *ngIf="featuredTitles?.length > 1; else singleFeaturedTitle"
      [swiperConfig]="singleItemSwiperConfig"
      #singleItemSwiper appSwiperConfig
      (swiperslidechange)="swiperSlideChanged($any($event))"
    >
      <swiper-slide *ngFor="let featuredTitle of featuredTitles">
        <div
          class="single-titles__item many-item"
          *ngIf="featuredTitle.type === 'image'"
          [style.backgroundImage]="
            'url(' + (featuredTitle.previewUrl ?? featuredTitle.thumbnailUrl) + ')'
          "
        ></div>
        <div class="single-titles__item" *ngIf="featuredTitle.type === 'video'">
          <vg-player class="single-titles__item--video">
            <video
              [vgHls]="featuredTitle.previewUrl"
              #sliderVideo
              id="singleVideo"
              type="video/mp4"
              [muted]="true"
              preload="auto"
              controls
              [autoplay]="true"
            ></video>
          </vg-player>
        </div>
      </swiper-slide>
    </swiper-container>
    <ng-template #singleFeaturedTitle>
      <div class="single-titles__item one-item" *ngIf="featuredTitles[0]?.type === 'image'">
        <img
          class="single-titles__item--image"
          [src]="featuredTitles[0].previewUrl ?? featuredTitles[0].thumbnailUrl"
          alt="featured title image"
        />
      </div>

      <div class="single-titles__item" *ngIf="featuredTitles[0]?.type === 'video'">
        <vg-player class="single-titles__item--video">
          <video
            [vgHls]="featuredTitles[0].previewUrl"
            #sliderVideo
            id="singleVideo"
            type="video/mp4"
            [muted]="true"
            preload="auto"
            controls
            [autoplay]="true"
          ></video>
        </vg-player>
      </div>
    </ng-template>
  </div>
  <ng-template #loadingFeaturedTitles>
    <div class="mx-3" [style.display]="showFT ? 'block' : 'none'">
      <ngx-skeleton-loader
        [count]="1"
        [animation]="'progress-dark'"
        [theme]="{
          height: '40vh',
          'border-radius': '10px',
          'background-color': '#101010',
          border: '1px solid #101010',
          'animation-duration': '2s'
        }"
      >
      </ngx-skeleton-loader>
    </div>
  </ng-template>


  <div *ngFor="let asset of assetsArray; let i = index">
    <div
    class="on-release-titles multiple-titles"
    *ngIf="getForLoopValue(asset.id)?.length > 0; else assetTemplate"
  >
    <h1 class="multiple-titles__header">
      {{ getLabel(asset.id) }}
    </h1>
    <div *ngIf="asset.id === 2" class="assets_all">
      <a [routerLink]="['assets/titles']" class="link-title">{{
        'see-all-assets-label' | translate
      }}</a>
    </div>
    <swiper-container appSwiperConfig [swiperConfig]="multipleItemSwiperConfig" >
      <swiper-slide
        *ngFor="let onReleaseTitle of getForLoopValue(asset.id); trackBy: trackByOnRelease"
        ><app-home-title [title]="onReleaseTitle" [isOnRelease]="true" [category]='assetsArray[i].code'></app-home-title>
      </swiper-slide>
    </swiper-container>
  </div>
  <ng-template #assetTemplate>
    <div [style.display]="showRT ? 'block' : 'none'">
      <div class="d-flex overflow-hidden my-3 ms-2">
        <ngx-skeleton-loader
          class="loading-item"
          [count]="10"
          [animation]="'progress-dark'"
          appearance="circle"
          [theme]="{
            width: '20rem',
            height: '30rem',
            'margin-right': '2rem',
            'border-radius': '10px',
            'background-color': '#101010',
            border: '1px solid #101010',
            'animation-duration': '2s'
          }"
        >
        </ngx-skeleton-loader>
      </div>
    </div>
  </ng-template>
  </div>
</section>
